import { Component, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Subject, switchMap, takeUntil } from 'rxjs';

import { ISupplementFileDialogData } from 'editing-tool/src/app/shared/components/paper/steps/supplements/supplement-file-dialog/supplement-file-dialog-dialog-data';
import { ValidationConstants, ValidationService } from 'sc-common';
import { FileUploadComponent } from 'sc-external/shared/components/file-upload/file-upload.component';

@Component({
    templateUrl: './supplement-file-dialog.component.html',
    standalone: false
})
export class SupplementFileDialogComponent implements OnDestroy {

    public readonly form: UntypedFormGroup;

    public readonly dialogData: ISupplementFileDialogData;

    public requestInProcess = false;

    private readonly _destroy$ = new Subject<void>();

    @ViewChild('fileUpload')
    private readonly _fileUpload: FileUploadComponent;

    constructor(
        private readonly _formBuilder: UntypedFormBuilder,
        private readonly _dialogRef: DynamicDialogRef,
        dialogConfig: DynamicDialogConfig) {

        this.form = this._buildForm();

        this.dialogData = dialogConfig.data;
    }

    public ngOnDestroy(): void {

        this._destroy$.next();
        this._destroy$.complete();
    }

    public onUploadCompleted(): void {
        this.requestInProcess = false;
        this._dialogRef.close(true);
    }

    public addSupplementFile(): void {

        if (this.form.invalid || !this._fileUpload.validate()) {
            this.form.markAllAsTouched();
            return;
        }

        this.requestInProcess = true;

        this.dialogData.action(this.form.value)
            .pipe(
                switchMap(supplementId => this.dialogData.getUploadUrl(supplementId)),
                takeUntil(this._destroy$))
            .subscribe(uploadUrl => this._fileUpload.startUpload(uploadUrl));
    }

    private _buildForm(): UntypedFormGroup {

        return this._formBuilder.group(
            {
                description: [
                    null,
                    [Validators.required, ValidationService.alphaNumSymbolValidator, Validators.maxLength(ValidationConstants.Max500Length)]]
            });
    }
}
